import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import Footer from "./components/Footer";
import ClientSideError from "./pages/errors/ClientError";
import StaticBlogOnAwsServerless from "./pages/articles/StaticBlogOnAwsServerless";
import AwsSubjectMatterExpert from "./pages/articles/AwsSubjectMatterExpert";
import AwsGameday from "./pages/articles/AwsGameday";
import AwsLondonSummit from "./pages/articles/AwsLondonSummit";
import AwsReinvent2024 from "./pages/articles/AwsReinvent2024";
import LambdaProxy from "./pages/articles/LambdaProxy";
import AppSyncDynamoSingleTableDesign from "./pages/articles/AppSyncDynamoSingleTableDesign";
import AwsLandingZonesControlTower from "./pages/articles/AwsLandingZonesControlTower";
import OidcInPipelinesGithubActions from "./pages/articles/OidcInPipelinesGithubActions";
import LambdaSqsEventProcessing from "./pages/articles/LambdaSqsEventProcessing";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <div className="app">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/blog" element={<Blog />} />
          <Route exact path="/blog/static-blog-on-aws-serverless" element={<StaticBlogOnAwsServerless />} />
          <Route exact path="/blog/aws-subject-matter-expert" element={<AwsSubjectMatterExpert />} />
          <Route exact path="/blog/aws-gameday" element={<AwsGameday />} />
          <Route exact path="/blog/aws-london-summit" element={<AwsLondonSummit />} />
          <Route exact path="/blog/lambda-proxy" element={<LambdaProxy />} />
          <Route exact path="/blog/aws-reinvent-2024" element={<AwsReinvent2024 />} />
          <Route exact path="/blog/appsync-dynamodb-single-table-design" element={<AppSyncDynamoSingleTableDesign />} />
          <Route exact path="/blog/aws-landing-zones-control-tower" element={<AwsLandingZonesControlTower />} />
          <Route exact path="/blog/oidc-in-pipelines-github-actions" element={<OidcInPipelinesGithubActions />} />
          <Route exact path="/blog/lambda-sqs-event-processing" element={<LambdaSqsEventProcessing />} />
          <Route path="*" element={<ClientSideError />} />
        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
